import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { useBookingsByEventQuery } from "@/features/event/hooks/use-events-query";

import { EventSessions } from "../-components/event-sessions";

export const Route = createFileRoute("/_auth/org/$orgId/event/$eventId/sessions/")({
  component: Page
});

function Page() {
  const { event } = useRouteContext({
    from: "/_auth/org/$orgId/event/$eventId/sessions/"
  });

  const { data: bookings = [] } = useBookingsByEventQuery(event.id);

  return (
    <div className="py-4 md:py-6">
      <EventSessions event={event} bookings={bookings} />
    </div>
  );
}
